import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ObjectPreviewPanelProps } from './types';

type EntryPointParams = {};

type ObjectPreviewPanelEntryPointComponent = EntryPointComponent<
	{},
	Record<string, never>,
	ObjectPreviewPanelProps,
	Record<string, never>
>;

const objectPreviewPanelEntryPoint: EntryPoint<
	ObjectPreviewPanelEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<ObjectPreviewPanelEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/ObjectPreviewPanel" */ './index',
		{ moduleId: 'object-preview-panel-entrypoint' },
	),
	getPreloadProps: ({}: EntryPointParams) => ({}),
});

export default objectPreviewPanelEntryPoint;
